import React from 'react';
import { Switch } from 'react-router-dom';

import { PERMISSIONS, ROUTES } from '../../../constants';
import PrivateRoute from '../../../routes/PrivateRoute';
import { Labels } from '../pages/Labels';

// Mesma permissão dos Parâmetros: configuração da empresa.
export const LabelsRoute: React.FC = () => (
  <Switch>
    <PrivateRoute
      path={ROUTES.labels}
      permission={PERMISSIONS.COMPANY_PARAMS_VIEW}
      component={Labels}
    />
  </Switch>
);
